// Framework and third-party non-ui
import React, { useState } from 'react';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import Popover from '@material-ui/core/Popover';
import { makeStyles } from '@material-ui/core/styles';

// JSON & Styles
import { StyledSubmitFeedbackButton } from './SubmitFeedback-styled';

// Third-party components (buttons, icons, etc.)

const SubmitFeedback = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const useStyles = makeStyles((theme) => ({
  popoverPaper: {
    backgroundColor: '#ffffff'
  },
  cancel: {
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '20px',
    /* identical to box height, or 143% */
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    letterSpacing: '0.25px',
    padding: '7px',
    color: 'red',
    cursor: 'pointer',
    "&:hover, &:focus": {
      backgroundColor: "#E0E0E0"
    },
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
      width: '220px',
      alignContent: 'center',
    },
    link: {
      fontFamily: 'Open Sans',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: '14px',
      lineHeight: '20px',
      /* identical to box height, or 143% */
      display: 'flex',
      alignItems: 'center',
      textAlign: 'center',
      letterSpacing: '0.25px',
      padding: '7px',
      cursor: 'pointer',
      "&:hover, &:focus": {
        backgroundColor: "#E0E0E0"
      },
      whiteSpace: 'break-spaces',
    }
  }));

  const goToSurvey = (i) => {
    if(i === 1) window.open("https://survey123.arcgis.com/share/e911c01e84194de28660d82663f8c6f5", "_blank");
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const classes = useStyles();

  return (
    <>
    <StyledSubmitFeedbackButton color="secondary"
     data-testid="SubmitFeedback" onClick={handleClick} aria-label="Submit Feedback Dropdown">
      FEEDBACK <KeyboardArrowDownIcon />
    </StyledSubmitFeedbackButton>
              <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose ={handleClose}
                anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
                }}
                transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
                }}
                classes={{paper: classes.popoverPaper}}
              >
                <div class={classes.container}>
                  <div class={classes.link} onClick={() => {goToSurvey(1)}}>Provide DE<strong>TOUR</strong> Feedback</div>
                  <div class={classes.cancel} onClick={handleClose}>Cancel</div>
                </div>
              </Popover>
    </>
  );
};

export default SubmitFeedback;
